import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";

/**
 * Fetches both the list of available personalities and the user's active personality.
 * Returns a combined result matching the original API shape.
 */
export function usePersonalities() {
  const $ = _c(11);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = {
      queryKey: QUERY_KEYS.ACTIVE_PERSONALITY,
      queryFn: () => apiFetcher("/api/v1/assistant/active_personality"),
      staleTime: 300000,
      gcTime: 600000
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: activePersonality,
    isLoading,
    isError
  } = useQuery(t0);
  let t1;
  if ($[2] !== apiFetcher) {
    t1 = {
      queryKey: QUERY_KEYS.PERSONALITIES,
      queryFn: () => apiFetcher("/api/v1/assistant/personalities"),
      staleTime: 600000,
      gcTime: 1800000
    };
    $[2] = apiFetcher;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: personalities,
    isLoading: personalitiesLoading,
    isError: personalitiesError
  } = useQuery(t1);
  let t2;
  if ($[4] !== activePersonality || $[5] !== isError || $[6] !== isLoading || $[7] !== personalities || $[8] !== personalitiesError || $[9] !== personalitiesLoading) {
    t2 = {
      activePersonality,
      personalities,
      isLoading,
      personalitiesLoading,
      isError,
      personalitiesError
    };
    $[4] = activePersonality;
    $[5] = isError;
    $[6] = isLoading;
    $[7] = personalities;
    $[8] = personalitiesError;
    $[9] = personalitiesLoading;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}